import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ProgramManagement.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { setModality, removeModality } from './ModalitiesSlice';
import { setDevice, removeDevice} from './AddProgramSlice';
import ManagementDropdownCard from '../../components/ManagementDropdownCard';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { getInitialStartTime, initSelectedDevices } from '../../utils/programUtils';

const DeviceSetup = ({errors}) => {
    const {groupId} = useSelector((state)=>state.addProgram.program);
    const allDevices = useSelector((state)=>state.programTemplateLists.devices);
    const filteredDevices = allDevices.filter((device)=>device.groupId === groupId);
    const dispatch = useDispatch();
    const programDevices = useSelector((state)=>state.addProgram.devices);
    const programModalities = useSelector((state)=>state.modalities.modalities);
    const [selectedDevices, setSelectedDevices] = useState(initSelectedDevices(programDevices, allDevices));

    const deviceInfo = {
        deviceId: '',
        deviceModalityId: 0,
        lowerLimit: 0,
        upperLimit: 0,
        targetValue: 0,
        isAlarmActive: false,
        startTime: getInitialStartTime(),
        frequency: 1,
        interval: "Day",
        readingType: "Automated",
        isContinuous: false
    };

    const modalityInfo = {
        deviceId: '',
        deviceModalityId: '',
        upperLimit: 0,
        lowerLimit: 0,
        targetValue: 0,
        isAlarmActive: false,
        isContinuous: false,
        startTime: getInitialStartTime(),
        frequency: 1,
        interval: "Day"
    };

    const checkSelectedItem = (deviceId) => {
        return selectedDevices.some(item => item.deviceId === deviceId);
    };

    const handleDeviceChange = (device) => {
        let deviceInList = false;
        // check if device is already in selectedDevices
        selectedDevices.forEach((item)=>{
            if (item.deviceId===device.deviceId){
                deviceInList = true;
            } 
        });
        if (deviceInList){
            // remove device + device modalities from selectedDevices, program slice, and modalities slice
            setSelectedDevices(selectedDevices.filter(item => item.deviceId !== device.deviceId));
            dispatch(removeDevice(device.deviceId));
            dispatch(removeModality(device.deviceId));
        } else {
            setSelectedDevices([device, ...selectedDevices]);
            let tempDevice = {...deviceInfo};
            tempDevice.deviceId = device.deviceId;
            dispatch(setDevice(tempDevice));
            // add a new modality object for each modality in device
            device.modalities.forEach((m)=>{
                let tempModality = {...modalityInfo};
                tempModality.deviceId = device.deviceId;
                tempModality.deviceModalityId = m.deviceModalityId;
                
                // Initialize values as is - they should already be in Celsius from the API
                tempModality.upperLimit = m.upperLimit || 0;
                tempModality.lowerLimit = m.lowerLimit || 0;
                tempModality.targetValue = m.targetValue || 0;
                
                dispatch(setModality(tempModality));
            })
        }
    };

    const removeDeviceCard = (id) => {
        setSelectedDevices(selectedDevices.filter(item => item.deviceId !== id));
        dispatch(removeDevice(id));
        dispatch(removeModality(id));
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"10px", paddingBottom:"10px"}}>
            <MultiSelectDropdown 
                options={filteredDevices}
                label='listLabel'
                checkedKey='deviceId'
                checkSelectedItem={checkSelectedItem}
                handleChange={handleDeviceChange}
                selectedItems={selectedDevices}
                name='Devices'
            />
            {errors.showing && 
                <div className={styles.ValidationMessageContainer}>
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="xs" style={{color:"red"}}/>
                    <span className={styles.ValidationMessage}>
                        {errors.message}
                    </span>
                </div>
            }
            <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
                {selectedDevices.map((device, index) => (
                    <div key={device.deviceId}>
                        <ManagementDropdownCard 
                            open={index === 0}
                            cardInfo={{title:device.model, id:device.deviceId, type:"Device", modalities:device.modalities}} 
                            removeHandler={removeDeviceCard}
                            updateHandler={setDevice}
                            dataList={programDevices}
                            setModality={setModality}
                            errorShowing={errors}
                            modalityList={programModalities}
                            allDevices={allDevices}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default DeviceSetup;